<ng-container *ngIf="(show$ | push)">
    <ng-container
        *ngTemplateOutlet="
            optionTemplateRef; 
            context: { 
                articles$, 
                count$, 
                status$,
                pageParams$,
                displayPage,
                scrollInToView$,
                pager$
            }"
    ></ng-container>
</ng-container>
